const DB_URL = '/.netlify/functions/db-access'

export async function databaseAccess(db_params) {
    let db_call_params = {
        body: JSON.stringify(db_params),
        method: "POST",
        "Content-Type": "application/json",
    };
    return await fetch(DB_URL, db_call_params);
};

export function elementDisplay(item_name, display) {
    let item = document.getElementById(item_name);
    item.style.display = display;
};

export function elementVisibility(item_name, visibility) {
    let item = document.getElementById(item_name);
    item.style.visibility = visibility;
};

export function isUndefined(value) {
    if (typeof value == 'undefined') {
        return true;
    };
    return false;
};

export function setText(element_name, value) {
    let element = document.getElementById(element_name)
    if (element != null) {
        element.innerText = value;
    }
 }

 export function setHTML(element_name, value) {
     let element = document.getElementById(element_name)
     element.innerHTML = value
  }

export function setValue(element_name, value) {
    let element = document.getElementById(element_name)
    element.value = value
}

export function setFocus(element_name) {
    document.getElementById(element_name).focus();
}

export function getStyle(element_name, style_name) {
    let element = document.getElementById(element_name);
    let compStyles = window.getComputedStyle(element);
    let style_value = compStyles.getPropertyValue(style_name);
    return style_value;
}

export function getValue(element_name) {
    let element = document.getElementById(element_name)
    if (element != null) {
       return element.value;
    }
 }

 export function getText(element_name) {
     let element = document.getElementById(element_name)
     if (element != null) {
        return element.innerText;
     }
  }
